export default __webpack_public_path__ + "assets/9f0c63551478450af484981d04bdc51b.png";